// extracted by mini-css-extract-plugin
export default {"form":"ProfilePage_form__UHe59"};